module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"header":"Choose a template","editOptions":"Edit options","sendDocumentEmpty":"Send HelloSign document","documentsHeader":"Templates","search":"Search","emptySearch":"No results found for \\"{search}\\"","errorLoadingDocuments":"There was an issue loading your HelloSign documents."}}')
  delete Component.options._Ctor
}
